import { useState } from "react";
import { Link } from "react-router-dom";

const EPISODES = [
  { id: "1", title: "The Science of Meditation and Consciousness", duration: "42 min", date: "Apr 20, 2026", desc: "Exploring how modern neuroscience validates ancient meditation practices.", icon: "🧠" },
  { id: "2", title: "Astral Travel: A Beginner's Guide", duration: "38 min", date: "Apr 13, 2026", desc: "Introduction to astral projection, out-of-body experiences, and conscious dreaming.", icon: "🌌" },
  { id: "3", title: "Vegetarianism and the Spiritual Path", duration: "31 min", date: "Apr 6, 2026", desc: "Why ancient wisdom traditions emphasize plant-based living for spiritual advancement.", icon: "🌿" },
  { id: "4", title: "Understanding the Five Elements", duration: "45 min", date: "Mar 30, 2026", desc: "Deep dive into earth, water, fire, air, and ether in spiritual practice.", icon: "🌊" },
  { id: "5", title: "Dream Journaling for Spiritual Growth", duration: "28 min", date: "Mar 23, 2026", desc: "How to use your dreams as a map to your subconscious and spiritual self.", icon: "🌙" },
];

export function PodcastPage() {
  const [playing, setPlaying] = useState<string | null>(null);

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Listen &amp; Learn</p>
          <h1 className="display-2">Podcast</h1>
          <p className="hero__body" style={{ maxWidth: "540px", margin: "0 auto" }}>
            Conversations on meditation, consciousness, dreams, and the journey to inner awakening.
          </p>
          <div style={{ marginTop: "1.5rem", display: "flex", gap: "0.75rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="#" className="btn btn--outline-light btn--sm">🍎 Apple Podcasts</a>
            <a href="#" className="btn btn--outline-light btn--sm">🎵 Spotify</a>
            <a href="#" className="btn btn--outline-light btn--sm">▶️ YouTube</a>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container container--reading">
          <div className="podcast-list">
            {EPISODES.map((ep) => (
              <div key={ep.id} className="podcast-episode-card">
                <div className="podcast-episode-card__icon">{ep.icon}</div>
                <div className="podcast-episode-card__body">
                  <h3 className="podcast-episode-card__title">{ep.title}</h3>
                  <p className="podcast-episode-card__meta">{ep.date} · {ep.duration}</p>
                  <p className="podcast-episode-card__desc">{ep.desc}</p>
                </div>
                <button
                  className={`podcast-play-btn ${playing === ep.id ? "playing" : ""}`}
                  onClick={() => setPlaying(playing === ep.id ? null : ep.id)}
                  aria-label={playing === ep.id ? "Pause" : "Play"}
                >
                  {playing === ep.id ? "⏸" : "▶"}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sticky player placeholder */}
      {playing && (
        <div className="podcast-sticky-player">
          <div className="container">
            <div className="podcast-sticky-player__inner">
              <span>{EPISODES.find((e) => e.id === playing)?.icon}</span>
              <div>
                <p className="podcast-sticky-player__title">
                  {EPISODES.find((e) => e.id === playing)?.title}
                </p>
              <p className="podcast-sticky-player__sub">Aekam Podcast</p>
              </div>
              <div className="podcast-sticky-player__controls">
                <button className="podcast-play-btn playing" onClick={() => setPlaying(null)}>⏸</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
